import {
  SwitchChainError as EvmSwitchChainError,
  BaseError as ViemBaseError,
} from "viem"
import {
  ConnectorChainMismatchError as EvmConnectorChainMismatchError,
  BaseError as WagmiBaseError,
} from "wagmi"
import {
  ConnectorChainMismatchError,
  InsufficientFundsError,
  InternalWalletError,
  LedgerError,
  PolychainError,
  RequestExpiredError,
  SwitchChainError,
  TransactionRevertedError,
  UnknownRpcError,
  WalletRejectedError,
} from "./errors"
import { isInsufficientFundsError } from "./isInsufficientFundsError"
import { isInternalWalletError } from "./isInternalWalletError"
import { isLedgerError } from "./isLedgerError"
import { isRequestExpiredError } from "./isRequestExpiredError"
import { isUnknownRpcError } from "./isUnknownRpcError"
import { isUserRejectedRequestError } from "./isUserRejectedRequestError"
import { walk } from "./walk"

export function parseTransactionError(error: unknown): PolychainError {
  if (error instanceof PolychainError) {
    // already translated to polychain, no need to wrap
    return error
  }

  if (!(error instanceof WagmiBaseError || error instanceof ViemBaseError)) {
    return new TransactionRevertedError(error as Error)
  }

  if (isUserRejectedRequestError(error)) {
    return new WalletRejectedError(error)
  }

  if (isInsufficientFundsError(error)) {
    return new InsufficientFundsError()
  }

  if (isLedgerError(error)) {
    return new LedgerError(error)
  }

  if (isRequestExpiredError(error)) {
    return new RequestExpiredError(error)
  }

  if (isInternalWalletError(error)) {
    return new InternalWalletError(error)
  }

  if (isUnknownRpcError(error)) {
    return new UnknownRpcError(error)
  }

  if (walk(error, e => e instanceof EvmSwitchChainError)) {
    return new SwitchChainError(error)
  }

  if (walk(error, e => e instanceof EvmConnectorChainMismatchError)) {
    return new ConnectorChainMismatchError(error)
  }

  return new TransactionRevertedError(error)
}
